var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-status-legend"},_vm._l((_vm.statusList),function(statusItem,i){return _c('div',{key:i,staticClass:"legend-item"},[_c('div',{staticClass:"legend-color",style:(`background-color: var(--v-${statusItem.color}-base);`)}),_c('span',[_vm._v(_vm._s(_vm.testStatusTranslation(statusItem.text)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }